module.exports = __webpack_public_path__ + "static/img/pic_questionnaire.45524d66.png";